// Notes about import maps. You can import 3 ways:
// Absolute path:
// import React from "/Users/DHH/projects/basecamp/node_modules/react"
// Relative path:
// import React from "./node_modules/react"
// HTTP path:
// import React from "https://ga.jspm.io/npm:react@17.0.1/index.js"
// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails

// pins like "@hotwired/turbo-rails" are defined in config -> importmap.rb
// NOTE importmaps is just for js NOT css

import "@hotwired/turbo-rails"
import "jquery"

import "@popperjs/core"
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";
window.bootstrap = bootstrap;

import "./plugins/sb-admin-2"
import "./controllers"

import Sortable from "./plugins/sortable.min";
// Expose Sortable globally
window.Sortable = Sortable;

// Clean up Select2 instances before Turbo caches the page to avoid duplicates on back navigation
document.addEventListener('turbo:before-cache', () => {
  if (typeof jQuery === 'undefined') return;

  // Destroy Select2 instances
  jQuery('.select2-hidden-accessible').each(function() {
    const $el = jQuery(this);
    if ($el.data('select2')) {
      $el.select2('destroy');
    }
  });

  // Remove any lingering Select2 containers
  document.querySelectorAll('.select2-container').forEach((container) => container.remove());
});

// Import and expose BulkEditTable utilities globally
import { BulkEditTable, calculateField, closest } from "./utils/bulk_edit_table.js";
window.BulkEditTable = BulkEditTable;
window.calculateField = calculateField;
window.closest = closest;


// import "./plugins/select2_4_0_13.min"
// import "./plugins/select2_4_0_13_ru.min"

// using my own version of moment

// add the string.format method
if (!String.prototype.format) {
  String.prototype.format = function() {
    var args = arguments;
    return this.replace(/{(\d+)}/g, function(match, number) { 
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
      ;
    });
  };
}

// function that tries to get a param from the query string
window.getParameterByName = function(name, url) {
   if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

// load on each page load
$(document).off('turbo:load').on('turbo:load', function() {

  // IMPORTANANT TURBO PREFETCHES BY Defaut on mouseover and that must stop!
  if (Turbo.navigator.linkPrefetchingIsEnabledForLocation) {
    Turbo.navigator.linkPrefetchingIsEnabledForLocation = () => false;
  }

  $(document).off('click', '.simple-collapse').on("click", ".simple-collapse", function(e){
    // toggle the collapse class on this
    $(this).toggleClass('collapsed');
    // toggle the show on all the aria-controls
    $('.' + $(this).attr('aria-controls')).toggleClass("hide");    
  });

  $(document).off('click', '.print-modal').on('click', '.print-modal', function(e){
    var printContents = document.querySelector('.modal-dialog').innerHTML;
    var originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    
    // Reload Bootstrap scripts to restore modal functionality after printing
    setTimeout(function() {
      location.reload();
    }, 1000);
  });
  
  // This opens select2 pickers on focus
  $(document).on('focus', '.select2-selection.select2-selection--single', function (e) {
    const selectElement = $(this).closest(".select2-container").siblings('select:enabled');
    // Only open if Select2 is initialized on this element
    if (selectElement.length) {
      const select2Data = selectElement.data('select2');
      // Check that Select2 is initialized and has the necessary methods
      if (select2Data && select2Data.isOpen !== undefined && typeof selectElement.select2 === 'function') {
        try {
          selectElement.select2('open');
        } catch (error) {
          // Silently ignore if Select2 is not fully initialized or method doesn't exist
        }
      }
    }
  });
  // This opens select2 pickers on focus
  // steal focus during close - only capture once and stop propogation
  $('select.select2').on('select2:closing', function (e) {
    $(e.target).data("select2").$selection.one('focus focusin', function (e) {
      e.stopPropagation();
    });
  });

  $(document).off('click', '.close-modal').on('click', '.close-modal', function(e){
    let m = $(this).parents('.modal');
    if(modal){ m.modal('hide')}
  });
  

  // if they ever change the current business
  $(document).off('change', '#selected_business').on('change', '#selected_business', function () {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('set_current_business', $(this).val());
    window.location.search = '?' + urlParams.toString(); // full redirect
  });


  $(document).off('click', '.save-and-add-btn').on('click', '.save-and-add-btn', function(e){
  	
  	$(this).parents('form').find('#save_add_another').val(true);
  	$(this).parents('form').submit();
  });

  // Dynamic nested form code
  $(document).off('click', '.remove_fields').on('click', '.remove_fields', function(e){

    if($(this).hasClass('confirm-remove')){
      if(!confirm("DELETE this record?")){
        return e.preventDefault();    
      }
    }

    $(this).prev('input[type=hidden]').val('1');
    $(this).closest('.nested_form_row').addClass('removed').hide();
    $(this).trigger("after_remove_fields_click");
    return e.preventDefault();
  });

  // Dynamic nested form code
  $(document).off('click', '.add_fields').on('click', '.add_fields', function(e){
    var regexp, time;
    time = new Date().getTime();
    regexp = new RegExp($(this).data('id'), 'g');    

    var add_before_el = $(this);
    if($(this).data('add-before'))
      add_before_el = $('#' + $(this).data('add-before'))
    
    var newFields = $($(this).data('fields').replace(regexp, time));
    add_before_el.before(newFields);
    
    // $(this).before($(this).data('fields').replace(regexp, time));
    // Focus on the first non-hidden input, select, or textarea
    var firstInput = newFields.find('input:not([type=hidden]), select, textarea').first();
    if (firstInput.length) {
      firstInput.focus();
    }
    
    $(this).trigger("after_add_fields_click");

    return e.preventDefault();
  });

  // Open date picker on click (only for user-initiated clicks, not programmatic)
  $(document).on('click', 'input[type="date"]', function(e) {
    // Only call showPicker if this is a real user click (not programmatic)
    // Check if the event is trusted (user-initiated)
    if (e.isTrusted) {
      try {
        this.showPicker();
      } catch (error) {
        // showPicker() requires a user gesture, ignore if it fails
        // The native date picker will still work on user interaction
        if (error.name !== 'NotAllowedError') {
          console.warn('Error opening date picker:', error);
        }
      }
    }
  });

  if(getParameterByName('show_tab')){
    $('.nav-pills button[id="{0}"]'.format(getParameterByName('show_tab'))).tab('show');
  }
  
  // Generic field highlighting function
  const highlightId = getParameterByName('highlight_id');
  if (highlightId) {
    // Add highlighting CSS if not already present
    if (!document.getElementById('field-highlight-styles')) {
      const style = document.createElement('style');
      style.id = 'field-highlight-styles';
      style.textContent = `
        .field-highlight {
          background-color: #fff3cd !important;
          border-color: #ffeaa7 !important;
          box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.25) !important;
          transition: all 0.5s ease-out;
        }
        .field-highlight .select2-container {
          background-color: #fff3cd !important;
        }
      `;
      document.head.appendChild(style);
    }
    
    // Find the element by ID
    const targetElement = document.getElementById(highlightId);
    if (targetElement) {
      // Find the closest form-group container
      const fieldContainer = targetElement.closest('.form-group');
      if (fieldContainer) {
        // Add highlight class
        fieldContainer.classList.add('field-highlight');
        
        // Also highlight Select2 container if it exists
        setTimeout(function() {
          const select2Container = targetElement.nextElementSibling;
          if (select2Container && select2Container.classList.contains('select2-container')) {
            select2Container.classList.add('field-highlight');
          }
        }, 100);
        
        // Remove highlight after 3 seconds
        setTimeout(function() {
          fieldContainer.classList.remove('field-highlight');
          const select2Container = targetElement.nextElementSibling;
          if (select2Container && select2Container.classList.contains('select2-container')) {
            select2Container.classList.remove('field-highlight');
          }
        }, 3000);
        
        // Scroll to the field
        fieldContainer.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center' 
        });
      }
    }
  }
  
  // Now run the js on each individual page
  const myEvent = new Event('on_individual_page_js');
  document.dispatchEvent(myEvent);
}) //End turbo:load

